import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/atoms/Button';

import './FilterDaysBy.scss';
const ns = 'filter-days';

class FilterDaysBy extends React.Component {
  constructor(props) {
    super(props);
    this.selectOption = this.selectOption.bind(this);
  }

  selectOption(option) {
    const { filterDaysBy, setApplicationFilterDaysBy } = this.props;
    setApplicationFilterDaysBy(filterDaysBy === option ? null : option);
  }

  getButtons(selected) {
    return (
      <div className={`${ns}__buttons-container`}>
        <Button
          className={`${ns}__button ${
            selected === 'morning' ? `${ns}__button--active` : ''
          }`}
          onClick={() => this.selectOption('morning')}
          value="morning"
          id="morning_button"
        >
          Morning
        </Button>
        <Button
          className={`${ns}__button ${
            selected === 'afternoon' ? `${ns}__button--active` : ''
          }`}
          onClick={() => this.selectOption('afternoon')}
          value="afternoon"
          id="afternoon_button"
        >
          Afternoon
        </Button>
      </div>
    );
  }

  render() {
    const { filterDaysBy } = this.props;
    return <div className={ns}>{this.getButtons(filterDaysBy)}</div>;
  }
}

FilterDaysBy.propTypes = {
  filterDaysBy: PropTypes.string,
  setApplicationFilterDaysBy: PropTypes.func.isRequired
};

FilterDaysBy.defaultProps = {};

export default FilterDaysBy;



// WEBPACK FOOTER //
// ./src/components/molecules/FilterDaysBy/FilterDaysBy.js